export const APP_VERSION = process.env.REACT_APP_VERSION || 0.0;
export const APP_DEPLOY = process.env.REACT_APP_DEPLOY_DATE || '07 Nov 2024';
